import { container } from './container';
import { FeatureFlagsLoader } from '../feature-flags/feature-flags-loader';
import { ServiceIds } from './service-ids';
import { ConfigProxyHandler } from './config';
import { TaxLoader } from '../../general/modules/Taxes/TaxLoader/TaxLoader';
import { FeeService } from '../../general/modules/Taxes/Fee/FeeService';
import { LocalStorageCache } from '../../cache/localStorageCache';
import { VatService } from '../../general/modules/Taxes/VAT/VatService';

export function setupCommon() {
    container.bind<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER)
        .toConstantValue(new FeatureFlagsLoader(window.app.config.featureFlags));

    container.bind(ServiceIds.CONFIG)
        .toConstantValue(new Proxy(window.app.config, new ConfigProxyHandler()));

    container.bind(ServiceIds.FEE_SERVICE)
        .toConstantValue(new FeeService(new LocalStorageCache(), new TaxLoader()));

    container.bind(ServiceIds.VAT_SERVICE)
        .toConstantValue(new VatService(new LocalStorageCache(), new TaxLoader()));
}
